// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"RecurrenceCancellation--checkboxContainer--b5bbbc"};